import { useState, useEffect } from "react";
import { Select, message, Modal } from 'antd';
import { DropzoneArea } from 'material-ui-dropzone';
import { useHistory } from 'react-router-dom'

import Layout from "../Layout/Layout";
import Header from "../Components/Header";
import Achievement from "../Components/Achievement";
import ServiceCards from "../Components/ServiceCards";
import { url, header } from "../Constent/Constant";
import GetQuoteForm from "../Components/GetQuoteForm";

const { Option } = Select;

function OurService() {
  const [ServiceData, setServiceData] = useState('')
  const [To, setTo] = useState('')
  const [From, setFrom] = useState('')
  const [MovingType, setMovingType] = useState('')
  const [FormDate, setFormDate] = useState('')
  const [Phone, setPhone] = useState('')
  const [HeadingUpdate, setHeadingUpdate] = useState('')
  const [TextModalVisible, setTextModalVisible] = useState(false);
  const [ImageUpdate, setImageUpdate] = useState(null)
  const [ImageModal, setImageModal] = useState(false);
  const [UpdateId, setUpdateId] = useState('')
  const history = useHistory()

  const LoggedIn = localStorage.getItem('MS-Login')
  if (LoggedIn !== 'true') {
    history.push('/')
  }

  useEffect(() => {
    UpdateData()
  }, [])

  const UpdateData = () => {
    fetch(`${url}/page/viewpagedata`, {
      method: 'POST',
      body: JSON.stringify({
        name: "Our Services"
      }),
      headers: header
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        setServiceData(data.doc)
      })
  }

  const handleChange = (value) => {
    setMovingType(value)
  }

  const OnFormSubmit = () => {
    if (Phone === '' || From === '' || To === '' || FormDate === '' || MovingType === '') {
      message.error('Fill All Fields ')
    }
    else {
      fetch(`${url}/page/serviceinquiry`, {
        method: 'POST',
        body: JSON.stringify({
          data: {
            movingtype: MovingType,
            from: From,
            to: To,
            date: new Date(),
            phone: Phone
          }
        }),
        headers: header
      })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          if (data.message === 'Success') {
            message.success('From Fill Successfully')
          }
        })
    }
  }

  const UpdateText = (DataObject) => {
    console.log(DataObject)
    if (DataObject !== '') {
      fetch(`${url}/page/updatedata`, {
        method: 'POST',
        body: JSON.stringify({
          id: DataObject.id,
          content: DataObject.text
        }),
        headers: header
      })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          if (data.message === 'Success') {
            UpdateData()
          }
        })
    }
  }

  const UpdateImage = (DataObject) => {
    const Imagedata = new FormData();
    Imagedata.append('image', DataObject.image)
    Imagedata.append('id', DataObject.id)

    fetch(`${url}/page/updateimage`, {
      method: 'POST',
      body: Imagedata
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        if (data.message === 'Success') {
          UpdateData()
        }
      })
  }

  const handleCancel = () => {
    setTextModalVisible(false);
    setImageModal(false);
  };

  const ShowTextModal = (id) => {
    setTextModalVisible(true);
    setUpdateId(id)
  };

  const showImageModal = (id) => {
    setImageModal(true);
    setUpdateId(id)
  };

  const TextHandle = () => {
    if (HeadingUpdate === '') {
      message.error('Fill the Field')
    } else {
      UpdateText({
        text: HeadingUpdate,
        id: UpdateId
      })
      setTextModalVisible(false);
      setHeadingUpdate('')
    }
  };

  const OnImageHandle = () => {
    if (ImageUpdate === null) {
      message.error('Insert Image')
    } else {
      UpdateImage({
        image: ImageUpdate,
        id: UpdateId
      })
      setImageModal(false);
    }
  };

  const OnEnterPress = (event) => {
    const a = HeadingUpdate
    console.log(a)
    if (event.key === 'Enter') {
      console.log('Enter Clicked')
      a.concat('\n')
      setHeadingUpdate(a)
    } else {
      console.log(event.key)
    }
  }


  return (
    <Layout>
      {ServiceData && <Header
        UpdateText={UpdateText}
        UpdateImage={UpdateImage}
        GetData={{
          imgId: ServiceData.section1image1._id,
          headingId: ServiceData.section1heading1._id
        }}
        Image={ServiceData.section1image1.image} />}

      {ServiceData && <div className='Service-Container'>
        <div className='Service-info'>
          <p className='info-subheading'> {ServiceData.section2subheading1.content}
            <i onClick={() => ShowTextModal(ServiceData.section2subheading1._id)} className="far fa-edit Edit-btn"></i>
          </p>
          <h2 className='Heading'> {ServiceData.section2heading1.content}
            <i onClick={() => ShowTextModal(ServiceData.section2heading1._id)} className="far fa-edit Edit-btn"></i>
          </h2>
          <div className='Service-List'>
            <i onClick={() => ShowTextModal(ServiceData.section2paragraph1._id)} className="far fa-edit Edit-btn"></i>
            <p className='Service-para'>  {ServiceData.section2paragraph1.content} </p>
          </div>
          {/* <button className='Secondary-btn Button'>Discover more</button> */}
        </div>

        <div className='Service-Form'>
          <div className='Form-Container'>
            <div className='input-div'>
              <h6>Moving Type</h6>
              <Select defaultValue="local Moving" style={{ width: 120 }} onChange={handleChange} >
              <Option value="Local Moving">Local Moving</Option>
                <Option value="Long Distance">Long Distance</Option>
                <Option value="Commercial Moving">Commercial Moving</Option>
                <Option value="Military Moving">Military Moving</Option>
              </Select>
            </div>
            <div className='Section-1'>
              <div className='input-1'>
                <h6>From</h6>
                <input value={From} onChange={e => setFrom(e.target.value)} className='Input' placeholder='City,State' />
              </div>
              <div className='input-2'>
                <h6>To</h6>
                <input value={To} onChange={e => setTo(e.target.value)} className='Input' placeholder='City,State' />
              </div>
            </div>
            <div className='Section-1'>
              <div className='input-1'>
                <h6>Date</h6>
                <input value={FormDate} onChange={e => setFormDate(e.target.value)} className='Input' placeholder='mm/dd/yyyy' />
              </div>
              <div className='input-2'>
                <h6>Phone #</h6>
                <input value={Phone} onChange={e => setPhone(e.target.value)} className='Input' placeholder='ex : +4321098765' />
              </div>
            </div>
            <button onClick={OnFormSubmit} className='Secondary-btn Button'>SUBMIT</button>
          </div>
        </div>
      </div>}

      {ServiceData && <ServiceCards
        UpdateText={UpdateText}
        UpdateImage={UpdateImage}
        CardData={ServiceData} />}

      {/* {ServiceData && <div className='Service-tip-section'>
        <i onClick={() => showImageModal(ServiceData.section4image1._id)} className="far fa-edit Edit-btn"></i>
        <img src={`${url}/api/getFile${ServiceData.section4image1.image}`} alt='img' draggable='false' />
        <div className='Image-Blank'></div>
        <h3>{ServiceData.section4heading1.content}
          <i onClick={() => ShowTextModal(ServiceData.section4heading1._id)} className="far fa-edit Edit-btn"></i>
        </h3>
        <p>{ServiceData.section4paragraph1.content}
          <i onClick={() => ShowTextModal(ServiceData.section4paragraph1._id)} className="far fa-edit Edit-btn"></i>
        </p>
        <i class="fas fa-play-circle"></i>
      </div>} */}

      {ServiceData && <Achievement
        UpdateText={UpdateText}
        UpdateImage={UpdateImage}
        CardSection={{
          image: ServiceData.section5image1.image,
          imageId: ServiceData.section5image1._id,
          heading: ServiceData.section5heading1.content,
          headingId: ServiceData.section5heading1._id,
          para: ServiceData.section5paragraph1.content,
          paraId: ServiceData.section5paragraph1._id,
        }} />}

      {
        ServiceData && <GetQuoteForm UpdateImage={UpdateImage}
          imageID={ServiceData.image._id} image={ServiceData.image.image} />
      }


      {/* Update Text Modal */}
      <Modal width={400} style={{ top: '20%' }} title='Update Text' visible={TextModalVisible} onOk={TextHandle} onCancel={handleCancel} okText="Update" >
        <textarea onKeyPress={(e) => OnEnterPress(e)} value={HeadingUpdate} onChange={e => setHeadingUpdate(e.target.value)} className='Input' placeholder='Update Heading...' />
      </Modal>

      {/* Update Image Modal */}
      <Modal width={700} style={{ top: '5%' }} title='Update Image' visible={ImageModal} onOk={OnImageHandle} onCancel={handleCancel} okText="Update" >
        <DropzoneArea
          filesLimit={1}
          acceptedFiles={['image/*']}
          dropzoneText={"Update Product Images"}
          onChange={(files) => {
            console.log('Files:', files[0])
            setImageUpdate(files[0])
          }}
        />
      </Modal>



    </Layout>
  );
}

export default OurService;
